import { MenuItem, StoredLinkData } from '../types';
import { isExternalLink } from '../util';

export function sortMenuItems(
    items: ReadonlyArray<MenuItem>,
): ReadonlyArray<MenuItem> {
    return items
        .slice(0)
        .sort((a: MenuItem, b: MenuItem) => a.sortOrder - b.sortOrder);
}

export function storedLinkDataToMenuItem(
    id: string,
    { to, external, label, boldLabel, sortOrder, subItems }: StoredLinkData,
): MenuItem & { sortOrder: number } {
    let mappedSubItems;

    const formattedTo =
        !isExternalLink(to) && !to.startsWith('/') ? `/${to}` : to;

    if (subItems) {
        mappedSubItems = sortMenuItems(
            Object.keys(subItems).map((key: string) =>
                storedLinkDataToMenuItem(key, subItems[key]),
            ),
        );
    }

    return {
        id,
        to: formattedTo,
        external,
        label,
        boldLabel,
        sortOrder,
        subItems: mappedSubItems,
    };
}

export function menuItemToStoredLinkData(
    { to, external, label, boldLabel = '' }: Omit<MenuItem, 'id'>,
    sortOrder: number,
): StoredLinkData {
    return {
        to,
        external,
        label,
        boldLabel,
        sortOrder,
    };
}
